import React from "react";
import FacebookLogin from 'react-facebook-login';
//import InstagramLogin from 'react-instagram-login';
import GoogleLogin from 'react-google-login';
import imageInstagram from '../../images/instagram.png';
import imageGoogle from '../../images/gl-logo2.png';
import imageVk from '../../images/vk-social.svg';
import imageTw from '../../images/tw-logo.png';

export default (props) => {

    const {
        errorMessages,
        socialFBCallBack,
        handleINST,
     //   handleOnChange,
        onSwitcher,
        socialGoogleCallback,
        handleVK,
        handleTwitter,
        connecting,

        facebook,
        instagram,
        google,
        vk,
        twitter
    } = props;

    return (
        <div className="white-block-content">

            <ul className={"data-with-labels"}>
                <li>
                    <div className={"checkboxes checkboxes_align-left"}>
                        <ul className="data-with-labels">
                        <li>
                                <div style={{ verticalAlign: 'middle', display: 'flex', alignItems: 'center' }}>
                                        {
                                            facebook
                                            ?
                                            <button
                                                onClick={(e) => { onSwitcher(facebook ? false : true, 'facebook') }}
                                                style={{ marginRight: 10 }}
                                                >Отключить</button>
                                            :
                                            <FacebookLogin
                                                appId="202889673626661"
                                                autoLoad={false}
                                                isDisabled={connecting.fb ? true : false}
                                                fields={['email']}
                                                scope={['email']}
                                                callback={socialFBCallBack}
                                                textButton=''
                                                cssClass="test-fb-button"
                                                icon="fa-facebook"
                                            />
                                    }
                                    <span className="text">FACEBOOK</span>
                                    {
                                        connecting.fb
                                        ? <span className="soc-nt-loading-span">Подключается...</span>
                                        : null
                                    }
                                </div>
                            </li>
                            {/* <li>
                                <div style={{ verticalAlign: 'middle', display: 'flex', alignItems: 'center' }}>
                                    {
                                        instagram 
                                        ? 
                                        <button onClick={(e) => { onSwitcher(instagram ? false : true, 'instagram') }} style={{ marginRight: 10 }}>Отключить</button>
                                        :
                                        <img src={imageInstagram} onClick={handleINST} width={"30"} height={"30"} style={{ marginRight: 10, cursor: 'pointer' }}/>

                                        // <InstagramLogin
                                        //     clientId="202889673626661"
                                        //     buttonText="Login"
                                        //     onSuccess={socialINSTCallBack}
                                        // />
                                    }
                                    <span className="text">INSTAGRAM</span>
                                    {
                                        connecting.in
                                        ? <span className="soc-nt-loading-span">Подключается...</span>
                                        : null
                                    }
                                </div>
                            </li> */}
                            <li>
                            <div style={{ verticalAlign: 'middle', display: 'flex', alignItems: 'center' }}>
                                    {
                                        google
                                        ?
                                        <button
                                            onClick={(e) => { onSwitcher(google ? false : true, 'google') }}
                                            style={{ marginRight: 10 }}
                                            >Отключить</button>
                                        :
                                        <GoogleLogin
                                            clientId={`491145896490-t5i7j0sd5f31pacm0k9sehlljb0o5vq7.apps.googleusercontent.com`}
                                            buttonText=''
                                            disabled={connecting.gl ? true : false}
                                            autoLoad={false}
                                            redirectUri='https://fixfact.ru'
                                            style={{width: '30px', height: '30px', border: 'none', padding: 0, marginRight: '10px', backgroundColor: 'transparent'}}
                                            onSuccess={response => socialGoogleCallback(response,true)}
                                            onFailure={(response) => socialGoogleCallback(response, false)}
                                        >
                                            <img
                                                src={imageGoogle}
                                                style={{ width: '30px', cursor: 'pointer' }}
                                                alt="vk icon"
                                            />
                                        </GoogleLogin>
                                    }
                                    <span className="text">GOOGLE</span>
                                    {
                                        connecting.gl
                                        ? <span className="soc-nt-loading-span">Подключается...</span>
                                        : null
                                    }
                                </div>
                            </li>
                            <li>
                                <div style={{ verticalAlign: 'middle',display: 'flex', alignItems: 'center' }}>
                                    {
                                        vk
                                        ?
                                        <button
                                            onClick={(e) => { onSwitcher(vk ? false : true, 'vk') }}
                                            style={{ marginRight: 10 }}
                                        >
                                            Отключить
                                        </button>
                                        :
                                        <a>
                                            <img
                                                src={imageVk}
                                                style={{ width: '30px', marginRight: '5px', cursor: 'pointer' }}
                                                alt="vk icon"
                                                onClick={handleVK}
                                            />
                                        </a>
                                    }
                                    <span className="text">VKONTAKTE</span>
                                    {
                                        connecting.vk
                                        ? <span className="soc-nt-loading-span">Подключается...</span>
                                        : null
                                    }
                                </div>
                            </li>
                            {/* <li>
                                <div style={{ verticalAlign: 'middle', display: 'flex', alignItems: 'center'}}>
                                    {
                                        twitter
                                        ?
                                        <button
                                            onClick={(e) => { onSwitcher(twitter ? false : true, 'twitter') }}
                                            style={{ marginRight: 10 }}
                                        >
                                            Отключить
                                        </button>
                                        :
                                        <a>
                                            <img
                                                src={imageTw}
                                                style={{ width: '30px', marginRight: '5px', cursor: 'pointer' }}
                                                alt="tw icon"
                                                onClick={handleTwitter}
                                            />
                                        </a>
                                    }
                                    <span className="text">TWITTER</span>
                                    {
                                        connecting.tw
                                        ? <span className="soc-nt-loading-span">Подключается...</span>
                                        : null
                                    }
                                </div>
                            </li> */}
                        </ul>
                    </div>
                </li>
            </ul>
        </div >
    )
}


// WEBPACK FOOTER //
// ./src/components/Account/SocialNetworkForm.js